import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import * as category from '../../appRedux/actions/category'
import * as common from '../../appRedux/actions/common'
import * as router from '../../constants/router'
import Loading from '../../components/loading'
import Header from '../../components/header'

function CategoryDetailsVideo(props) {
    let { id } = useParams()
    let categoryDetailsId = ""
    let categoryId = ""
    id = id.replace(':id', '')
    id = id.split(',')
    categoryId = id[0]
    if (id.length === 2)
        categoryDetailsId = id[1]

    useEffect(() => {
        emptyId()
        getCategoryDetailsVideo()
    }, [])

    const emptyId = () => {
        if (id === "" || categoryDetailsId === "") {
            props.redirectAction(router.HOME)
        }
    }

    const getCategoryDetailsVideo = () => {
        props.categoryDetailsVideoAction(categoryId, categoryDetailsId)
    }

    return (
        <React.Fragment>
            {props.loadingPage ? <Loading /> :
                <Header
                    title={props.categoryDetails.title}
                    redirectLink={router.CATEGORY_DETAILS + categoryId} />}
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
        loadingPage: state.common.loadingPage,
        categoryDetails: state.common.categoryDetails
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        redirectAction: (router) => dispatch(common.redirectAction(router)),
        categoryDetailsVideoAction: (categoryId, categoryDetailsId) => dispatch(category.categoryDetailsVideoAction(categoryId, categoryDetailsId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CategoryDetailsVideo)
